import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ScrollBar from 'components_v2/common/ScrollBar';
import classNames from 'classnames';
import { wait, inViewForReact } from 'utils/common';
import Header from 'components_library/molecules/Header/Header';
import analyticsWrapper from 'components_library/utils/analyticsWrapper';
import PopupPortal from 'components_v2/mobile/PopupPortal';
import s from './MobileTabs.scss';

const MobileTabs = props => {
  const { onChangeCallback, ga, typeShemaClassNames } = props;

  let { tabs } = props;
  if (!(Array.isArray(tabs) && tabs.length > 0)) return null;
  tabs = tabs.filter(item => item.name);

  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [l2selected, setL2Selected] = useState(false);
  const [activeSearchString, setActiveSearchString] = useState('');
  const [itemNameSelected, setItemNameSelected] = useState();
  const [selectedL1Index, setSelectedL1Index] = useState(0);
  const [updateScroll, setUpdateScroll] = useState(true);
  const [opened, setOpened] = useState(false);
  const [mounted, setMounted] = useState(false);
  const listRef = useRef(null);

  let prevSelectedVal;

  useEffect(() => {
    setFilteredItems(tabs);
  }, []);

  // useEffect(
  //   () => {
  //     if (typeof setActiveTab === 'function') {
  //       setActiveTab(itemNameSelected);
  //     }
  //   },
  //   [itemNameSelected],
  // );

  // useEffect(
  //   () => {
  //     if (
  //       typeof setActiveTab === 'function' &&
  //       Array.isArray(filteredItems) &&
  //       selectedIndex >= 0 &&
  //       filteredItems.length > selectedIndex &&
  //       filteredItems[selectedIndex] &&
  //       filteredItems[selectedIndex].name
  //     ) {
  //       setActiveTab(filteredItems[selectedIndex].name);
  //     }
  //   },
  //   [filteredItems],
  // );

  const updateListData = (e, item, index, selected) => {
    e.stopPropagation();
    if (!selected) {
      let selectedIndexToRender = index;
      if (l2selected && index > 1) {
        selectedIndexToRender -= 1;
      }

      onChangeCallback({ clickedItem: item });
      setSelectedL1Index(selectedIndexToRender);
      setL2Selected(false);
      setItemNameSelected(item.name);

      if (ga && ga.type) {
        analyticsWrapper('ga4', {
          event: 'user_click',
          type: ga.type,
          category: 'tab_change',
          label: item.name,
        });
      }
    }
  };

  const filterResults = searchString => {
    let filteredData = Array.isArray(tabs) ? tabs : [];
    if (searchString && filteredData && filteredData.length > 0) {
      const strLen = searchString.length;
      filteredData = [];
      let counter = 0;
      for (; counter < tabs.length; counter += 1) {
        if (
          tabs[counter].name.length >= strLen &&
          tabs[counter].name.toLowerCase().substring(0, strLen) === searchString
        ) {
          filteredData.push({ ...tabs[counter], itemIndex: counter });
        }
      }
    }
    setFilteredItems(filteredData);
    setActiveSearchString(searchString);
    setUpdateScroll(!updateScroll);
  };

  const openListingDropDown = async () => {
    setOpened(true);
    await wait(10);
    setMounted(true);
    document.body.classList.add(s.body_OH);
  };

  const closeListingDropdown = async () => {
    setMounted(false);
    await wait(500);
    document.body.classList.remove(s.body_OH);
    setOpened(false);
    setActiveSearchString('');
    filterResults('');
  };

  const setFocusToSelectedElement = () => {
    setTimeout(() => {
      if (listRef && listRef.current) {
        const selectedElem = listRef.current.getElementsByClassName(
          `${s.selected}`,
        );

        if (
          selectedElem &&
          selectedElem[0] &&
          prevSelectedVal !== selectedElem[0].innerText &&
          !inViewForReact(selectedElem[0])
        ) {
          const elem = selectedElem[0];
          prevSelectedVal = elem.innerText;
          const elemBoundary = elem.getBoundingClientRect();
          const elemEndPos = elemBoundary.left + elemBoundary.width;
          const windowWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
          if (elemEndPos > windowWidth) {
            listRef.current.scrollLeft += elemEndPos - windowWidth;
          } else if (elemBoundary.left < 0) {
            listRef.current.scrollLeft += elemBoundary.left;
          }
        }
      }
    }, 0);
  };

  const handleClick = (e, item, index) => {
    e.stopPropagation();
    onChangeCallback({ clickedItem: item });

    closeListingDropdown();
    setSelectedIndex(
      typeof item.itemIndex !== 'undefined' ? item.itemIndex : index,
    );
    setL2Selected(true);
    setItemNameSelected(item.name);
    if (ga && ga.type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: ga.type,
        category: 'tab_change',
        label: item.name,
      });
    }
  };

  useEffect(
    () => {
      if (l2selected && !itemNameSelected) {
        setFocusToSelectedElement();
      }
    },
    [selectedIndex, l2selected, itemNameSelected],
  );

  let showDropdown = true;
  let l1List = [];

  const tabCount = props.maxTabCount;
  let l1Len = 0;
  let selectedL1IndexToRender = selectedL1Index;

  if (!isNaN(tabCount)) {
    l1Len = parseInt(tabCount, 10);
  }
  const itemsInL1 = Math.min(l1Len, tabs.length);
  l1List = tabs.slice(0, itemsInL1);
  if (l1List.length > 0 && selectedIndex > l1List.length - 1 && l2selected) {
    l1List.splice(1, 0, tabs[selectedIndex]);
    selectedL1IndexToRender = 1;
    l1List = l1List.slice(0, itemsInL1);
  } else if (l2selected) {
    selectedL1IndexToRender = selectedIndex;
  }

  showDropdown = l1List.length < tabs.length;

  const containerClassName = classNames({
    [s.my_dropdown]: true,
    [s.listing]: mounted,
  });

  const showSearch = props.showSearchBox && tabs.length > 4;

  return (
    <>
      <div className={s.subsection}>
        <Header {...props.header} ga={ga}>
          {showDropdown && (
            <div className={s.change} onClick={openListingDropDown}>
              <span>
                <i />
                <i />
                <i />
              </span>
            </div>
          )}
        </Header>
        {l1List &&
          l1List.length > 0 && (
            <ul className={`${s.SubNav} ${typeShemaClassNames}`} ref={listRef}>
              {l1List.map((item, index) => (
                <li
                  key={index}
                  className={`${
                    index === selectedL1IndexToRender ? s.selected : ''
                  }`}
                  onClick={e =>
                    updateListData(
                      e,
                      item,
                      index,
                      index === selectedL1IndexToRender,
                    )
                  }
                >
                  {item.name}
                </li>
              ))}
            </ul>
          )}
      </div>

      {opened &&
        showDropdown && (
          <PopupPortal usePopupPortal>
            <div className={containerClassName}>
              <span className={s.backbg} onClick={closeListingDropdown} />
              <div className={`${s.outer} ${!showSearch ? s.scrollNone : ''}`}>
                {!showSearch && (
                  <span className={s.dropdown_heading}>
                    tap to change Category
                  </span>
                )}

                {showSearch && (
                  <div className={s.searchBox}>
                    <input
                      type="text"
                      placeholder="Search your Category"
                      onChange={event => {
                        filterResults(
                          event?.target?.value?.toLowerCase() || '',
                        );
                      }}
                      value={activeSearchString}
                    />
                  </div>
                )}
                <ScrollBar
                  tagElement="ul"
                  className={s.optionsList}
                  updateScroll={updateScroll}
                >
                  {filteredItems &&
                    filteredItems.length > 0 &&
                    filteredItems.map((item, index) => (
                      <li
                        className={
                          itemNameSelected === item.name ||
                          (!itemNameSelected &&
                            tabs &&
                            tabs[0].name === item.name)
                            ? [s.active]
                            : ''
                        }
                        key={item.name}
                        onClick={
                          item.active
                            ? undefined
                            : e => handleClick(e, item, index)
                        }
                      >
                        {item.name}
                      </li>
                    ))}
                  {!filteredItems ||
                    (filteredItems.length === 0 && <li>No Matches Found</li>)}
                </ScrollBar>
              </div>
            </div>
          </PopupPortal>
        )}
    </>
  );
};

MobileTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      link: PropTypes.string,
      active: PropTypes.bool,
    }),
  ),
  header: PropTypes.shape({}),
  onChangeCallback: PropTypes.func,
  showSearchBox: PropTypes.bool,
  ga: PropTypes.shape({}),
  maxTabCount: PropTypes.number,
};

MobileTabs.defaultProps = {
  tabs: undefined,
  header: undefined,
  showSearchBox: false,
  onChangeCallback: undefined,
  ga: undefined,
  maxTabCount: 4,
};

export default MobileTabs;
